import { appInfo } from '@weapp/utils';
export const mainClsPrefix = 'weapp-main';
export const headerClsPrefix = 'e10header';
export const mobMainClsPrefix = 'weapp-main-m';
export const mobAppSettingPrefix = 'weapp-setting-m';
export const mobWBClsPrefix = 'weapp-main-wb';
export const mobAppMngPrefix = "weapp-appmng-m";
export const mobAppDownloadPrefix = "weapp-appdownload-m";
export const mobTeamsSharePrefix = "weapp-appteamshare-m";
export const appMngDialogClsPrefix = "weapp-main-appmng-dialog";
export const menuSettingClsPrefix = 'weapp-main-menusetting';
export const teamsShareListPrefix = "weapp-appteamshare-list";
export const mobTeamsShareListPrefix = "weapp-appteamshare-list-m";
export const verifyButtonPrefix = "weapp-main-verifybutton";
export const layoutPublicUrl = appInfo('@weapp/layout').publicUrl || window.publicUrlstatic || '';
export const layoutPublicStatic = window.publicUrlstatic || '';
export const publicUrlapi = window.publicUrlapi || '';
export const comImportClsPrefix = `${mainClsPrefix}-import-data`;
export const primaryAndSecondaryIdentity = 'weapp-primary-and-secondary-identity'
export const mobPrimaryAndSecondaryIdentity = 'weapp-primary-and-secondary-identity-m'
export const mobIdentitySettingPrefix = "weapp-identity-setting-m"

//临时TEAMS全局变量
export const TEAMS = {
  currentUser: {
    admin: true,
    avatar: '',
    username: '王小二',
    department: {
      name: '项目协作组'
    }
  },
  currentTenant: {
    tenantName: '泛微网络科技',
    tenantKey: 't7akvdnf84'
  },
  service: {
    baseServer: 'https://apps.eteams.cn',
    baseweb: 'https://base.eteams.cn',
    passport: 'https://passport.mulinquan.cn',
    basic: 'https://www.yunteams.cn/basicapp',
    weapp: 'https://weapp.yunteams.cn',
  },
  tenantLogo: {
    logoUrl: `/static/img/global/eteams-logo_white@2x.png`,
    logoClickUrl: `/static/img/global/eteams-logo_black@2x.png`
  }
}

//ETEAMSID 用于免登请求
export const ETEAMSID = '3bf463f51693146e61813b5583d614e2'

//自定义应用图标对照表，兼容老数据
export const customAPPIcons = {
  '1': 'Icon-Approval-process-o'
}

//应用图标对照表
export const APPIcons = {
  'flow': 'Icon-Approval-process-o'
}


// 模块应用白名单
// 'demo' 标准demo
// 'workflow' 流程
// 'doc' 文档
// 'hrm' 人力
// 'crm' crm
// 'sms' 短信
// 'blog' 日报
// 'form' 表单
// 'task' 任务
// 'print' 打印
// ‘project’ 项目
// ‘meeting’ 会议
// 'fna' 财务
// 'formreport' form业务表单
// 'portal' 门户
// 'inc' 发票云
// 'mail' 邮件
// 'calendar' 日程管理
// 'cloudstore' 云商店
// 'cowork' 协助
// 'datarule' 数据规则库
// 'doccompare' 文档比对
// ‘eb’ 云桥
// ‘dw’ 数据仓库
// 'ebatch' 导入导出
// ebdapp  ebuilder应用中心
// ebdcoms ebuilder组件库
// ebddesigner  ebuilder设计器
// ebdform ebuilder表单后端
// ebdfpage  ebuilder表单前端视图(pc、m)
// ebdpage ebuilder页面运行视图(pc、m)
// edc 数据中心
// elog 日志模块
// emmanage 用户终端(管理后台配置界面)
// esb 集成中心-esb
// eschedule  任务调度
// escheduler  任务调度
// esearch 微搜模块
// excel
// file 文件服务
// formbuilder
// im 消息引擎
// mc 消息中心
// odoc 公文管理
// open 开放平台
// portrait 工作画像
// salary
// signcenter 印控中心
// sms 短信模块
// systemei
// tenant
// workflowchart
// goal 执行力模块
// performance
// plan
// market
// attend
// voice 语音

export const APPList: any = [
  'demo', 'fna', 'formreport', 'portal', 'inc', 'mail', 'market',
  'calendar', 'cloudstore', 'cowork', 'datarule', 'doccompare',
  'eb', 'dw', 'ebatch', 'ebdapp', 'ebdcoms', 'ebddesigner',
  'ebdform', 'ebdfpage', 'ebdpage', 'edc', 'elog', 'emmanage', 'performance',
  'esb', 'eschedule', 'escheduler', 'esearch', 'excel', 'file', 'plan',
  'formbuilder', 'im', 'mc', 'odoc', 'open', 'portrait', 'salary', 'cm',
  'signcenter', 'sms', 'systemei', 'tenant', 'workflowchart', 'goal',
  'workflow', 'doc', 'hrm', 'sms', 'crm', 'blog', 'form', 'voice', 'odocexchange',
  'task', 'print', 'project', 'meeting', 'attend', 'my', 'profile', 'placard', 'scene', 'verupgrade',
  'openapi', 'statistics', 'versionlog', 'free', 'openapi', 'paasapp', 'ebatch', 'monitor', 'statpage', 'techdoc', 'bussinessflow',
  'fnabudget', 'items', 'doccompare', 'fnaentbank', 'customerservice', 'cusapp', 'datasecurity', 'security', 'custom', 'architecture', 'recruit', 'analyze', 'statpage',
];

export const cacheLeftModules: any = ['task', 'project', 'doc', 'workflow'];


export const MAPPList: any = [
  'demo', 'fna', 'formreport', 'portal', 'inc', 'mail', 'market',
  'calendar', 'cloudstore', 'cowork', 'datarule', 'doccompare',
  'eb', 'dw', 'ebatch', 'ebdapp', 'ebdcoms', 'ebddesigner',
  'ebdform', 'ebdfpage', 'ebdpage', 'edc', 'elog', 'emmanage', 'performance',
  'esb', 'eschedule', 'escheduler', 'esearch', 'excel', 'file', 'plan',
  'formbuilder', 'im', 'mc', 'odoc', 'open', 'portrait', 'salary',
  'signcenter', 'sms', 'systemei', 'tenant', 'workflowchart', 'goal',
  'workflow', 'doc', 'hrm', 'sms', 'crm', 'blog', 'form', 'voice', 'odocexchange',
  'task', 'print', 'project', 'meeting', 'attend', 'my', 'profile', 'placard', 'bussinessflow',
  'statistics', 'free', 'openapi', 'paasapp', 'ebatch', 'monitor', 'statpage', 'fnaentbank', 'customerservice',
  'cusapp', 'datasecurity', 'security', 'cusapp', 'custom', 'architecture', 'fnabstravel', 'recruit', 'analyze', 'statpage',
];

export const horizontalClassNameList: string[] = [//横向导航宽度计算节点class名
  '.e10header-user',
  '.e10header-menu-home',
  '.e10header-menu-item-more',
  '.e10header-menu-em',
  '.e10header-quick',
  // '.e10header-menu-SubstituteItem',
  '.e10header-client-tool',
]
export const horizontalClassDefaultWidthMap = {
  '.e10header-user': 220,
  '.e10header-menu-home': 71,
  '.e10header-menu-item-more': 105,
  '.e10header-menu-em': 99,
  '.e10header-menu-SubstituteItem': 0,
  '.e10header-client-tool': 0,
}

export const verticalClassNameList: string[] = [//纵向导航宽度计算节点class名
  '.e10header-account',
  '.e10header-menu-home',
  '.e10header-menu-item-more',
  '.e10header-menu-em',
  '.e10header-user',
]

export const customMenuApps: any = ['workflow', 'task', 'doc', 'project'];



export const getCusAppModules = () => {
  let cusAppModules = [
    'customerservice', 'cowork', 'blog', 'goal', 'plan', 'sms', 'portal', 'doccompare', 'odocexchange', 'ebdapp',
    'meeting', 'performance', 'placard', 'odoc', 'bussinessflow', '/hrm/personnel',
    'scene', 'portrait', 'analyze',
    'task', 'project', 'calendar', 'market',
    'formreport',
    'mail', 'doc', 'workflow',
    '/hrm/orgsetting', '/hrm/hr', '/hrm/addressbook', '/hrm/payroll', 'statistics', 'profile',
    'attend', 'salary', 'signcenter', 'inc', 'fna', 'fnaentbank',
    '/crm/salechance', '/crm/price', '/crm/capital', '/crm/quote', '/crm/clue',
    '/crm/customer', '/crm/contact', '/crm/contract',
    // '/crm/contact', '/crm/contract',
    '/crm/orderform', '/crm/orderform_eworkspace',
    //下属空间
    '/crm/salechance_eworkspace', '/crm/price_eworkspace', '/crm/capital_eworkspace', '/crm/quote_eworkspace', '/crm/clue_eworkspace',
    '/crm/customer_eworkspace', '/crm/contact_eworkspace', '/crm/contract_eworkspace',
    // '/crm/contact_eworkspace', '/crm/contract_eworkspace',
    '/crm/marketactivity', '/crm/competitor', '/crm/production', '/crm/crmSummary',
    '/crm/marketactivity_eworkspace', '/crm/competitor_eworkspace', '/crm/production_eworkspace',
    'project_eworkspace', 'plan_eworkspace', 'doc_eworkspace', 'blog_eworkspace', 'goal_eworkspace', 'task_eworkspace', 'workflow_eworkspace',
  ];
  const curTenant = window.TEAMS?.currentTenant?.tenantKey || '';
  if (window.TEAMS?.runMode === 'beta' && window.TEAMS?.deploy === 'public') {
    cusAppModules = [
      'sms', 'meeting', 'blog', 'scene', 'bussinessflow', 'task', 'project', 'calendar', 'goal', 'plan', 'odoc', 'portal', 'odocexchange','ebdapp',
      'customerservice', '/hrm/personnel', 'performance', 'doc', 'mail', 'cowork',
      '/hrm/orgsetting', '/hrm/hr', '/hrm/addressbook', 'profile', 'fna', 'fnaentbank', 'statistics', 'formreport',
      'attend', 'salary', 'signcenter', 'inc', 'workflow', 'market', 'portrait',
      'plan_eworkspace', 'goal_eworkspace', 'project_eworkspace', 'task_eworkspace', 'doc_eworkspace', 'workflow_eworkspace',
      '/crm/marketactivity', '/crm/competitor', '/crm/production', '/crm/crmSummary',
      '/crm/orderform', '/crm/orderform_eworkspace', 'doccompare', 'analyze',
      '/crm/marketactivity_eworkspace', '/crm/competitor_eworkspace', '/crm/production_eworkspace',
      '/crm/salechance', '/crm/price', '/crm/capital', '/crm/quote', '/crm/clue', '/crm/customer', '/crm/contact', '/crm/contract',
      '/crm/salechance_eworkspace', '/crm/price_eworkspace', '/crm/capital_eworkspace', '/crm/quote_eworkspace', '/crm/clue_eworkspace', '/crm/customer_eworkspace', '/crm/contact_eworkspace', '/crm/contract_eworkspace'
    ];


  }
  if (window.TEAMS?.runMode === 'txproduction' && window.TEAMS?.deploy === 'public') {
    cusAppModules = ['sms', 'scene', 'meeting', 'bussinessflow', 'customerservice', 'portal', 'odocexchange','ebdapp',
      '/hrm/personnel', 'blog', 'goal', 'plan', 'odoc', 'task', 'project', 'calendar', 'performance', 'doc', 'mail', 'cowork',
      '/hrm/orgsetting', '/hrm/hr', '/hrm/addressbook', 'profile', 'fna', 'fnaentbank', 'statistics', 'formreport',
      'attend', 'salary', 'signcenter', 'inc', 'workflow', 'market', 'portrait',
      'project_eworkspace', 'task_eworkspace', 'doc_eworkspace', 'plan_eworkspace', 'goal_eworkspace', 'workflow_eworkspace',
      '/crm/marketactivity', '/crm/competitor', '/crm/production', '/crm/crmSummary',
      '/crm/orderform', '/crm/orderform_eworkspace', 'doccompare',
      '/crm/marketactivity_eworkspace', '/crm/competitor_eworkspace', '/crm/production_eworkspace',
      '/crm/salechance', '/crm/price', '/crm/capital', '/crm/quote', '/crm/clue', '/crm/customer', '/crm/contact', '/crm/contract',
      '/crm/salechance_eworkspace', '/crm/price_eworkspace', '/crm/capital_eworkspace', '/crm/quote_eworkspace', '/crm/clue_eworkspace', '/crm/customer_eworkspace', '/crm/contact_eworkspace', '/crm/contract_eworkspace'
      // '/crm/salechance', '/crm/price', '/crm/capital', '/crm/quote', '/crm/clue',
      // '/crm/salechance_eworkspace', '/crm/price_eworkspace', '/crm/capital_eworkspace', '/crm/quote_eworkspace', '/crm/clue_eworkspace',
    ];

  }
  // if (window.TEAMS?.deploy === 'private') {
  //   cusAppModules = cusAppModules.filter((it: any) => {
  //     return it !== 'attend'
  //   })
  // }
  return cusAppModules;
}





//此处保留这写法，抛给其他模块的就是个常量
export const cusAppModules: any = getCusAppModules();


// H5主框架内部模块
export const MInnerAPPList: any = ['uk'];
// crm模块-PC应用
export const CrmAPPList: any = ['customer'];
// crm模块-H5应用
export const MCrmAPPList: any = ['customer'];

export const unknowPageModuleSource: any = [
  'customapptotal', 'message', 'external', 'teamshare', 'ibms'
]
export const mUnknowPageModuleSource: any = [
  'customapptotal', 'message', 'info/wechat', 'info/wechatservice'
]
// 弹窗默认距离顶部的高度
export const DIALOG_BASE_TOP = 100
// 弹窗默认宽度
export const DIALOG_BASE_WIDTH = 500

export const hiddenNavigationList = [//不展示在导航上的菜单
  '/hrm/departmentSetting',
  '/hrm/groupManagement',
  '/hrm/orgBasicSetting',
  '/hrm/organizationDimensionsSetting',
  '/hrm/serialNumberSetting/subcompany',
  '/hrm/serialNumberSetting/department',
  '/hrm/serialNumberSetting/jobtitle',
  '/hrm/serialNumberSetting/employee',
  '/hrm/positionSetting',
  '/hrm/gradeSetting',
  '/hrm/matrixSetting',
  '/hrm/conditionMatrix',
  '/hrm/conditionMatrixBatch',
  '/hrm/privacySetting',
  '/hrm/cardSetting/subcompany',
  '/hrm/cardSetting/department',
  '/hrm/cardSetting/employee',
  '/hrm/personalCardDisplaySetting',
  '/hrm/browserDisplayFieldSetting',
  '/hrm/batch',
  '/hrm/officeLocationSetting',

  '/hrm/department',
  '/hrm/position',
  '/hrm/grade',

  '/hrm/orgsetting',
  '/hrm/addressbook',

  '/my/follow', //关注事项

  '/cusapp/404' //CUSAPP-404
]

export const cornerMarkModuleList = [//角标开发标准应用对接list
  { id: '2', module: 'workflow', apiPath: '/api/app/workflow/list/corner/getWfTodoCorner' },
  { id: '4', module: 'document', apiPath: '/api/doc/report/getDocumentUnReadCornerCount' },
]